import { FC, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "../styles/SipSuccessModal.css";

interface SipSuccessModalProps {
  show: boolean;
  title?: string;
  subtitle?: string;
  duration?: number; // in ms
  redirectLabel?: string;
  onComplete: () => void;
}

const SipSuccessModal: FC<SipSuccessModalProps> = ({
  show,
  title = "SIP Activated",
  subtitle = "Your investment plan is now live.",
  duration = 10000,
  redirectLabel = "Redirecting to Passbook",
  onComplete,
}) => {
  const [remainingMs, setRemainingMs] = useState(duration);

  useEffect(() => {
    if (!show) return;

    setRemainingMs(duration); // reset when opened

    const startTime = Date.now();

    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const newRemaining = duration - elapsed;

      if (newRemaining <= 0) {
        clearInterval(interval);
        setRemainingMs(0);
        onComplete();
      } else {
        setRemainingMs(newRemaining);
      }
    }, 200);

    return () => clearInterval(interval);
  }, [show, duration, onComplete]);

  const secondsLeft = Math.ceil(remainingMs / 1000);

  const progressPercentage =
    ((duration - remainingMs) / duration) * 100;

  return (
    <Modal
      show={show}
      centered
      backdrop="static"
      keyboard={false}
      contentClassName="sip-success-modal-pro"
    >
      <Modal.Body className="sip-success-body-pro">
        <div className="success-icon-wrapper">
          <svg className="success-icon" viewBox="0 0 52 52">
            <circle
              className="success-circle"
              cx="26"
              cy="26"
              r="24"
              fill="none"
            />
            <path
              className="success-check"
              fill="none"
              d="M16 27l7 7 14-14"
            />
          </svg>
        </div>

        <h5 className="success-title-pro">{title}</h5>
        <p className="success-subtitle-pro">{subtitle}</p>

        <div className="redirect-text" aria-live="polite">
          {redirectLabel} in{" "}
          <span className="countdown">{secondsLeft}s</span>
        </div>

        <div className="success-progress">
          <div
            className="success-progress-bar"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>

        <button
          className="redirect-now-btn"
          onClick={onComplete}
        >
          Redirecting to Passbook
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default SipSuccessModal;
